"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaGovernor = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var LunaGovernor = (function (_super) {
    __extends(LunaGovernor, _super);
    function LunaGovernor() {
        return _super.call(this, {
            cost: 4,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.EARTH],
            name: CardName_1.CardName.LUNA_GOVERNOR,
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.EARTH, 3); }),
            metadata: {
                cardNumber: 'C20',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(2); });
                }),
                description: 'Requires 3 Earth tags. Increase your M€ production 2 steps.',
            },
        }) || this;
    }
    LunaGovernor.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        return undefined;
    };
    return LunaGovernor;
}(Card_1.Card));
exports.LunaGovernor = LunaGovernor;
//# sourceMappingURL=LunaGovernor.js.map